import { render } from "./RevenueHistory.vue?vue&type=template&id=a280a8ea"
import script from "./RevenueHistory.vue?vue&type=script&lang=js"
export * from "./RevenueHistory.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__